export const STALE_TIME_30_SECONDS = 1000 * 30; // 30 SECONDS?
export const STALE_TIME_SHORT_SECONDS = 1000 * 10; // 30 SECONDS?
export const STALE_TIME_UNLIMITED = 0;
export const STALE_TIME_10_MINS = 10 * 60 * 1000; // 1 MINUTES
